import { toUTCDate } from "src/utils/date";

export const getStartDate = (yearMonth: string): Date => {
  return toUTCDate(`${yearMonth}-01`);
};

export const getMonthFromDate = (date: Date): string =>
  date.toISOString().substring(0, 7);

export const getMonth = (year: number, zeroBasedIndex: number): string =>
  getMonthFromDate(new Date(Date.UTC(year, zeroBasedIndex, 1)));

export const getDateFromMonth = (zeroBasedIndex: number): Date =>
  new Date(Date.UTC(1970, zeroBasedIndex, 1));

export const getYears = (minMonth: string, maxMonth: string): number[] => {
  const startYear = getStartDate(minMonth).getFullYear();
  const endYear = getStartDate(maxMonth).getFullYear();
  const years: number[] = [];
  for (let year = startYear; year <= endYear; year++) years.push(year);
  return years;
};
export const generateRange = (length: number): number[] =>
  Array.from(Array(length).keys());

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const distinct = (arr: any[]) => [...new Set(arr)];

export const toYears = (months: string[]): number[] => {
  let years: number[] = [];
  try {
    years = distinct(months.map(getStartDate).map((x) => x.getFullYear()));
  } catch {
    console.error("unable to parse years");
  }

  return years;
};
